export enum LinkTarget {
  SingleWindow,
  SingleTab,
  MultiWindow,
  MultiTab
}
